import { useEffect, useMemo } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthOutlined';
import { useData } from '../store/data';
import { useConfig } from '../store/config';
import { buildMonthKeys } from '../lib/months';
import { MonthsHeader } from './timeline/MonthsHeader';
import { ReleaseLayer } from './timeline/ReleaseLayer';
import { TrendRow } from './timeline/TrendRow';
import { Last30Days } from './timeline/Last30Days';

// Container: ein 18-Monats-Grid mit drei horizontalen Sektionen:
//   1) Header — Monats-Labels
//   2) Release-Layer — Bänder + SP-Phasen + SP-Marker
//   3) Ticket-Trend — Created und Resolved pro Monat
//
// Alle Sub-Komponenten teilen sich das gleiche grid-template, sodass die
// Spalten visuell aligned bleiben. Der Container scrollt horizontal,
// wenn die Viewport-Breite < 18 * 60 px ist.
export function Timeline() {
  const rowCount = useData(s => s.rows.length);
  const releaseCal = useConfig(s => s.releaseCal);
  const loadConfig = useConfig(s => s.loadFromBackend);

  useEffect(() => { void loadConfig(); }, [loadConfig]);

  const months = useMemo(() => buildMonthKeys(), []);

  if (!rowCount) return null;

  return (
    <Card>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
          <CalendarMonthIcon color="primary" />
          <Box sx={{ flex: 1 }}>
            <Typography variant="overline" color="text.secondary">Zeitachse</Typography>
            <Typography variant="body2" color="text.secondary">
              18 Monate · Releases &amp; Service Packs · Tickets pro Monat
            </Typography>
          </Box>
        </Stack>

        <Last30Days />

        <Box
          sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <Box sx={{ minWidth: 200 + months.length * 60 + 70 }}>
            <MonthsHeader months={months} />
            <ReleaseLayer months={months} releaseCal={releaseCal} />
            <TrendRow months={months} kind="created" />
            <TrendRow months={months} kind="resolved" />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
